<template>
  <div class="mock">
    <div class="login-confirm-box">
      <div class="icon-box">
      </div>
      <p class="tip">温馨提示</p>
      <p class="describe">您还未登录哦，快去登录吧~</p>
      <div class="btn-box">
        <span @click="clearTip('register')" class="register-btn">注册</span>
        <span @click="clearTip" class="login-btn">登陆</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "loginConfirm",
    methods: {
      clearTip(path) {
        if (path === 'register') {
          this.$router.push('/register')
        } else {
          this.$router.push('/login')
        }
      }
    }
  }
</script>

<style lang="less">
  .mock {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 2;
    background:rgba(51,51,51,0.15);
  }
  .login-confirm-box {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
    height: 290px;
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
    background-color: #fff;
    box-shadow: 0px 9px 21px 0px rgba(238, 238, 238, 1);
    border-radius: 8px;
    
    .icon-box {
      height: 20px;
    }
    
    .tip {
      font-size: 20px;
      color: #333;
      margin-top: 30px;
    }
    
    .describe {
      font-size: 16px;
      margin-top: 30px;
      color: #666;
    }
    
    .btn-box {
      width: 230px;
      margin: 30px auto 0;
      
      span {
        cursor: pointer;
        display: inline-block;
        width: 100px;
        line-height: 40px;
        height: 40px;
        opacity: 1;
        
        &:hover {
          opacity: .8;
        }
      }
      
      .register-btn {
        float: left;
        color: #D72923;
        border: 1px solid #D72923;
      }
      
      .login-btn {
        float: right;
        background-color: #D72923;
        color: #fff;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/loginConfirm.vue